import { isAxiosError } from "axios";

/** API envelopes may contain operator diagnostics. Only show our own copy. */
export function voiceErrorMessage(
  error: unknown,
  operation: "transcribe" | "debrief",
) {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  if (status === 401 || status === 403)
    return "Your session is unavailable. Choose Can't talk to keep your answers in the written form.";
  if (status === 429)
    return "Please wait a moment, then try again. You can also choose Can't talk.";
  if (operation === "transcribe") {
    if (status === 413)
      return "That answer was too large. Try a shorter recording.";
    if (status === 415)
      return "That audio format isn't supported. Try recording again, or choose Can't talk.";
    if (status === 400 || status === 422)
      return "Couldn't use that recording. Try recording again, or choose Can't talk.";
    return "Couldn't transcribe that answer. Try again, or choose Can't talk.";
  }
  if (status === 400 || status === 409 || status === 410)
    return "Couldn't continue this conversation. Your answer is still here; choose Can't talk to finish in writing.";
  return "Couldn't send your answer. It's still here; try again or choose Can't talk.";
}
